module.exports = __webpack_public_path__ + "media/images/emenu-now_fav_icon_blue-baf96bf3fcc3d073d667a3ce4a3e21cf.png";